import { useEffect, useState, useRef } from 'react';
import { withRouter } from '../WithRouterHOC';
import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { _change_nim_chat } from '../../store/Action';
import NimSession from '../nimSession';
import NimChat from '../nimChat';
import './ChatNim.scss';
import WEBIM from "../../store/WebNim.js";

const ChatNim = () => {
  const nimChatElement = useRef(null);
  const webim_visible = useSelector(store => store.webim_visible);
  const [currChat, setCurrChat] = useState(null);

  useEffect(() => {
    //更新对话对象
    WEBIM.onConfigFn('_SET_CURR_USER', (user) => {
      if (nimChatElement.current) {
        nimChatElement.current.changeToUser(user);
      } else {
        setCurrChat(user);
      }
    });

    return () => {
      WEBIM.onDeleteEvent('_SET_CURR_USER');
    }
  }, [webim_visible]);

  return (<Modal
    wrapClassName="iframe-body"
    open={webim_visible}
    centered={true}
    closable={false}
    footer={null}
    keyboard={false}
    maskClosable={false}
    zIndex={1001}
    width="1050px"
    height="700px"
  >
    <div className="chat-nim-window">
      <div className="chat-left">
        <NimSession isShowBanner={false} />
      </div>
      <div className="chat-right">
            <span
              className="window-action-inpage"
              onClick={_change_nim_chat.bind(this, null)}
            >
              <CloseOutlined />
            </span>
        <NimChat ref={nimChatElement} defaultToUser={currChat} />
      </div>
    </div>
  </Modal>)
}



export default withRouter(ChatNim, { withRef: true });
